
/**
 * 메시지 타입
 */
export type ChatMessageRequestType = typeof ChatMessageRequestType[keyof typeof ChatMessageRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatMessageRequestType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  FILE: 'FILE',
  LINK: 'LINK',
} as const;
